"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMintSupplyOrZero = exports.getMintSupply = exports.getAccountBalanceOrZeroStruct = exports.getAccountBalanceOrZero = exports.getAccountBalance = exports.getBalanceOrZero = exports.getVaultOwnerAndNonceForSpot = exports.getProgramIdForPerpProtocol = void 0;
var tslib_1 = require("tslib");
var anchor = tslib_1.__importStar(require("@project-serum/anchor"));
var anchor_1 = require("@project-serum/anchor");
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var decimal_js_1 = tslib_1.__importDefault(require("decimal.js"));
var __1 = require("../../");
var constants_1 = require("../../constants");
var getProgramIdForPerpProtocol = function (perpProtocol) {
    return perpProtocol === "Entropy" ? constants_1.ENTROPY_PROGRAM_ID : constants_1.MANGO_PROGRAM_ID;
};
exports.getProgramIdForPerpProtocol = getProgramIdForPerpProtocol;
var getVaultOwnerAndNonceForSpot = function (market) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var nonce, vaultOwner, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                nonce = new anchor.BN(0);
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 6];
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, web3_js_1.PublicKey.createProgramAddress([market.publicKey.toBuffer(), nonce.toArrayLike(Buffer, "le", 8)], __1.SERUM_PROGRAM_IDS.Mainnet)];
            case 3:
                vaultOwner = _a.sent();
                return [2 /*return*/, [vaultOwner, nonce]];
            case 4:
                e_1 = _a.sent();
                nonce.iaddn(1);
                return [3 /*break*/, 5];
            case 5: return [3 /*break*/, 1];
            case 6: return [2 /*return*/];
        }
    });
}); };
exports.getVaultOwnerAndNonceForSpot = getVaultOwnerAndNonceForSpot;
var getBalanceOrZero = function (token, account) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, err_1;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = decimal_js_1.default.bind;
                return [4 /*yield*/, token.getAccountInfo(account)];
            case 1: return [2 /*return*/, new (_a.apply(decimal_js_1.default, [void 0, (_b.sent()).amount.toString()]))()];
            case 2:
                err_1 = _b.sent();
                console.log(err_1);
                return [2 /*return*/, new decimal_js_1.default(0)];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getBalanceOrZero = getBalanceOrZero;
function getAccountBalance(connection, mintAddress, tokenAccount) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var token, account, balance;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = new spl_token_1.Token(connection, mintAddress, spl_token_1.TOKEN_PROGRAM_ID, null);
                    return [4 /*yield*/, token.getAccountInfo(tokenAccount)];
                case 1:
                    account = _a.sent();
                    balance = new anchor_1.BN(account.amount.toString());
                    return [2 /*return*/, { balance: balance, token: token }];
            }
        });
    });
}
exports.getAccountBalance = getAccountBalance;
function getAccountBalanceOrZero(connection, mintAddress, tokenAccount) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var balance;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getAccountBalanceOrZeroStruct(connection, mintAddress, tokenAccount)];
                case 1:
                    balance = (_a.sent()).balance;
                    return [2 /*return*/, balance];
            }
        });
    });
}
exports.getAccountBalanceOrZero = getAccountBalanceOrZero;
function getAccountBalanceOrZeroStruct(connection, mintAddress, tokenAccount) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var res, err_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAccountBalance(connection, mintAddress, tokenAccount)];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
                case 2:
                    err_2 = _a.sent();
                    return [2 /*return*/, { balance: new anchor_1.BN(0), token: null }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getAccountBalanceOrZeroStruct = getAccountBalanceOrZeroStruct;
function getMintSupply(connection, vaultMint) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var token, mintInfo, e_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = new spl_token_1.Token(connection, vaultMint, spl_token_1.TOKEN_PROGRAM_ID, null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, token.getMintInfo()];
                case 2:
                    mintInfo = _a.sent();
                    return [2 /*return*/, new decimal_js_1.default(mintInfo.supply.toString())];
                case 3:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [2 /*return*/, new decimal_js_1.default(0)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getMintSupply = getMintSupply;
function getMintSupplyOrZero(connection, vaultMint) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var err_3;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getMintSupply(connection, vaultMint)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_3 = _a.sent();
                    console.log(err_3);
                    return [2 /*return*/, new decimal_js_1.default(0)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getMintSupplyOrZero = getMintSupplyOrZero;
